/**
 * @generated SignedSource<<a66e1d911fcc22e30e751a00d896239f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type BillingPlan = "FREE" | "PRO" | "%future added value";
export type BillingStatus = "billed" | "unbilled" | "%future added value";
export type Currency = "BRL" | "USD" | "%future added value";
export type WorkspaceRole = "ADMIN" | "MEMBER" | "OWNER" | "%future added value";
export type DaySheetlyPageQuery$variables = {
  billingStatus?: BillingStatus | null | undefined;
  endDate?: string | null | undefined;
  projectId?: string | null | undefined;
  startDate?: string | null | undefined;
};
export type DaySheetlyPageQuery$data = {
  readonly projects: ReadonlyArray<{
    readonly color: string | null | undefined;
    readonly currency: Currency;
    readonly hourlyRate: number;
    readonly id: string;
    readonly name: string;
  }>;
  readonly tasks: ReadonlyArray<{
    readonly billingStatus: BillingStatus;
    readonly currency: Currency;
    readonly date: string;
    readonly description: string | null | undefined;
    readonly durationMinutes: number;
    readonly endDate: string | null | undefined;
    readonly hourlyRate: number;
    readonly id: string;
    readonly members: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }>;
    readonly project: {
      readonly color: string | null | undefined;
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly title: string;
  }>;
  readonly viewer: {
    readonly activeWorkspaceId: string | null | undefined;
    readonly email: string;
    readonly id: string;
    readonly name: string;
    readonly workspaces: ReadonlyArray<{
      readonly id: string;
      readonly members: ReadonlyArray<{
        readonly id: string;
        readonly role: WorkspaceRole;
        readonly user: {
          readonly email: string;
          readonly id: string;
          readonly name: string;
        };
      }>;
      readonly name: string;
    }>;
  } | null | undefined;
  readonly workspaceBilling: {
    readonly effectivePlan: BillingPlan;
  } | null | undefined;
};
export type DaySheetlyPageQuery = {
  response: DaySheetlyPageQuery$data;
  variables: DaySheetlyPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "billingStatus"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hourlyRate",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v10 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Project",
    "kind": "LinkedField",
    "name": "projects",
    "plural": true,
    "selections": [
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "billingStatus",
        "variableName": "billingStatus"
      },
      {
        "kind": "Variable",
        "name": "endDate",
        "variableName": "endDate"
      },
      {
        "kind": "Variable",
        "name": "projectId",
        "variableName": "projectId"
      },
      {
        "kind": "Variable",
        "name": "startDate",
        "variableName": "startDate"
      }
    ],
    "concreteType": "Task",
    "kind": "LinkedField",
    "name": "tasks",
    "plural": true,
    "selections": [
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "date",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "durationMinutes",
        "storageKey": null
      },
      (v7/*: any*/),
      (v8/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "billingStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "members",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      (v5/*: any*/),
      (v9/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "activeWorkspaceId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspaces",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkspaceMember",
            "kind": "LinkedField",
            "name": "members",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "role",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "WorkspaceBilling",
    "kind": "LinkedField",
    "name": "workspaceBilling",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "effectivePlan",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DaySheetlyPageQuery",
    "selections": (v10/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DaySheetlyPageQuery",
    "selections": (v10/*: any*/)
  },
  "params": {
    "cacheID": "96c53f858a66f1b609d5b8d12280582a",
    "id": null,
    "metadata": {},
    "name": "DaySheetlyPageQuery",
    "operationKind": "query",
    "text": "query DaySheetlyPageQuery(\n  $startDate: String\n  $endDate: String\n  $projectId: ID\n  $billingStatus: BillingStatus\n) {\n  projects {\n    id\n    name\n    color\n    hourlyRate\n    currency\n  }\n  tasks(startDate: $startDate, endDate: $endDate, projectId: $projectId, billingStatus: $billingStatus) {\n    id\n    title\n    description\n    date\n    endDate\n    durationMinutes\n    hourlyRate\n    currency\n    billingStatus\n    project {\n      id\n      name\n      color\n    }\n    members {\n      id\n      name\n    }\n  }\n  viewer {\n    id\n    name\n    email\n    activeWorkspaceId\n    workspaces {\n      id\n      name\n      members {\n        id\n        role\n        user {\n          id\n          name\n          email\n        }\n      }\n    }\n  }\n  workspaceBilling {\n    effectivePlan\n  }\n}\n"
  }
};
})();

(node as any).hash = "cd70aba836c9cd2ed473ee4f899d8dd3";

export default node;
